export default {
  fontFamily: "Poppins, Roboto, Helvetica, Arial, sans-serif",
  fontSize: 15,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  lineHeight: {
    sm: 1.25,
    md: 1.5,
    lg: 2
  }
};
